import { computed } from '@vue/composition-api';

/**
 * New / re-emerging entrants from the daily digest (`new_entrants`).
 * Reads the shared dailyDigest ref so the section stays in sync after load.
 *
 * @param {Object} params - Configuration
 * @param {import('@vue/composition-api').Ref<Object>} params.dailyDigest - dailyDigest ref from useDailyDigest
 * @param {import('@vue/composition-api').Ref<boolean>} params.loading - loading ref from useDailyDigest
 * @returns {Object} Reactive state for NewEntrantsSection
 */
export function useNewEntrantsSection({ dailyDigest, loading }) {
  const newEntrants = computed(() => {
    const list = dailyDigest.value?.new_entrants;
    return Array.isArray(list) ? list : [];
  });

  const loadingNewEntrants = loading;

  return {
    newEntrants,
    loading: loadingNewEntrants
  };
}
